<div class="modal-header d-flex justify-content-between align-items-center">
  <h5 class="m-0 fw-bold">User Profile</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
  <form [formGroup]="profileForm">
    <div class="card mb-3">
      <div class="card-header">
        <h6>Basic Information</h6>
      </div>
      <div class="card-body">
      <div class="row">
        <div class="col-lg-12">
          <div class="position-relative upload-btn m-auto">
            <img
              width="115"
              height="115"
              class="profile-image"
              id="wizardPicturePreview"
              [src]="profilePath()"
              (error)="setDefaultImage($event)"
              alt="Profile Picture"
            />
            @if (hasPhoto()) {
              <button
                type="button"
                class="image-remove-btn"
                title="Remove profile picture"
                aria-label="Remove profile picture"
                (click)="removeImage(fileInput)"
              >
                <span class="material-icons" aria-hidden="true">close</span>
              </button>
            }
            <label for="upload-btn" title="Change profile picture" aria-label="Change profile picture">
              <span class="material-icons" aria-hidden="true">edit</span>
            </label>
            <input
              #fileInput
              id="upload-btn"
              (change)="onFileChanged($event)"
              [title]="inputFileName"
              type="file"
              [accept]="accept"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-12">
          <div class="mb-2">
            <label class="form-label mb-1" for="firstName">First Name<span class="error-message"> *</span></label>
            <input
              type="text"
              class="form-control"
              id="firstName"
              maxlength="20"
              formControlName="FirstName"
              placeholder="Enter First Name"
              required
            />
            @if (submitted() && profileForm.controls['FirstName'].hasError('required')) {
              <div class="error-message">First Name is required</div>
            }
          </div>
        </div>
        <div class="col-lg-6 col-12">
          <div class="mb-2">
            <label class="form-label mb-1" for="lastName">Last Name<span class="error-message"> *</span></label>
            <input
              type="text"
              class="form-control"
              id="lastName"
              maxlength="20"
              formControlName="LastName"
              placeholder="Enter Last Name"
              required
            />
            @if (submitted() && profileForm.controls['LastName'].hasError('required')) {
              <div class="error-message">Last Name is required</div>
            }
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-12">
          <div class="mb-2">
            <label class="form-label mb-1" for="email">Email</label>
            <input
              type="email"
              class="form-control"
              id="email"
              maxlength="100"
              formControlName="Email"
              placeholder="Enter Email"
              [disabled]="true"
            />
            @if (submitted() && profileForm.controls['Email'].hasError('required')) {
              <div class="error-message">Email address is required</div>
            }
            @if (submitted() && profileForm.controls['Email'].hasError('pattern')) {
              <div class="error-message">Email address is not valid</div>
            }
          </div>
        </div>
        <div class="col-lg-6 col-12">
          <div class="mb-2">
            <label class="form-label mb-1" for="phoneNo">Phone</label>
            <input
              type="text"
              class="form-control"
              id="phoneNo"
              maxlength="10"
              placeholder="Enter Phone"
              formControlName="PhoneNo"
              oninput="this.value=this.value.replace(/^\./, '').replace(/[^\d.]/g,'').replace(/(\..*)\./g, '$1');"
            />
          </div>
        </div>
      </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="saveProfileData()">Save</button>
</div>

